import PublicLayout from './layouts/PublicLayout';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom'
import { getLocale, getUser, isUserLoggedIn } from './utils';
import LoginPage from 'features/auth/login';
import AdminLayout from './layouts/AdminLayout';
import NotFound from './features/misc/NotFound';
import Admin from './features/admin';
import Shops from './features/shops';
import Users from './features/users';
import { useEffect, useState, useMemo } from 'react';
import { setUiLocale } from 'app/i18n';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import RevenuePage from 'features/revenue';
import IngredientPage from 'features/sushi/pages/ingredient';
import BoxPage from 'features/sushi/pages/box';
import Netto from 'features/netto';
import ComputeSushi from 'features/sushi';
import InventoryPage from 'features/inventory';
import Notification from 'features/notification';
import CertificatePage from 'features/certificate';
import MapPage from 'features/map';
import { rolesMap } from 'components/SideBar/roles';
function App() {
  const [authState, setAuthState] = useState({
    isLoggedIn: isUserLoggedIn(),
    user: getUser()
  });

  useEffect(() => {
    setUiLocale(getLocale() || process.env.REACT_APP_DEFAULT_LOCALE)
  }, [])

  // Listen for authentication changes
  useEffect(() => {
    const handleStorageChange = () => {
      setAuthState({
        isLoggedIn: isUserLoggedIn(),
        user: getUser()
      });
    };

    // Listen for localStorage changes
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically for same-window changes
    const interval = setInterval(handleStorageChange, 100);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const { t } = useTranslation()

  const router = useMemo(() => createBrowserRouter([
    {
      path: "/",
      element: !authState.isLoggedIn ? <Navigate to='/login' /> : <Navigate to={rolesMap.includes(authState.user?.role) ? 'admin/map' : 'admin/timesheet'} />,
    },
    {
      path: "/login",
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <LoginPage />
        }
      ]
    },
    {
      path: "/admin",
      element: <AdminLayout />,
      children: [
        {
          path: "timesheet",
          element: <Admin />
        },
        {
          path: "users",
          element: <Users />
        },
        {
          path: "shops",
          element: <Shops />
        },
        {
          path: "ingredients",
          element: <IngredientPage />
        },
        {
          path: "boxes",
          element: <BoxPage />
        },
        {
          path: "calculator-sushi",
          element: <ComputeSushi />
        },
        {
          path: "revenues",
          element: <RevenuePage />
        },
        {
          path: "inventory",
          element: <InventoryPage />
        },
        {
          path: "netto",
          element: <Netto />
        },
        {
          path: "notification",
          element: <Notification />
        },
        {
          path: "certificate",
          element: <CertificatePage />
        },
        {
          path: "map",
          element: <MapPage />
        },
      ]
    },
    {
      path: "*",
      element: <NotFound />
    }
  ]), [authState.isLoggedIn, authState.user?.role]);

  return (
    <ConfigProvider form={{
      validateMessages: {
        required: t('required')
      }
    }}>
      <RouterProvider router={router} />
    </ConfigProvider>
  )
}

export default App
